import CheckBox from "../CheckBox";
import "./styles.scss";
import useApp from "../../hooks/useApp";

const DOC_TYPES = {
  TERMS: "terms_conditions",
  PRIVACY: "privacy_policy",
};

const AcceptOurConsent = ({ value = {}, onChange, onOpenTermsModal }) => {
  const { selectedLanguage, tenantConfig } = useApp();
  const lang = selectedLanguage?.value || "en";

  const handleLinkClick = (e) => {
    const anchor = e.target.closest?.("a");
    if (!anchor) return;

    const href = anchor.getAttribute("href") || "";

    e.preventDefault();
    e.stopPropagation();

    if (href.includes("{{privacy_policy_url}}")) {
      onOpenTermsModal?.(DOC_TYPES.PRIVACY);
      return;
    }

    if (href.includes("{{terms_conditions_url}}")) {
      onOpenTermsModal?.(DOC_TYPES.TERMS);
      return;
    }

    onOpenTermsModal?.(DOC_TYPES.TERMS);
  };

  const handleCheckboxChange = (position) => {
    const currentValue = value || {};
    const updatedValue = { ...currentValue };
    updatedValue[position] = !updatedValue[position];
    onChange(updatedValue);
  };

  return (
    <div className="consent-container">
      {tenantConfig?.user_consents?.content?.map((consent) => {
        const descriptionHTML = (consent.description?.[lang] || "").replace(
          /<a /g,
          '<a class="consent-link" '
        );

        return (
          <div className="accept-our-consent" key={consent.position}>
            <CheckBox
              value={value ? value[consent.position] === true : false}
              onChange={() => handleCheckboxChange(consent.position)}
            >
              <div
                className="consent-description"
                onClick={handleLinkClick}
                dangerouslySetInnerHTML={{ __html: descriptionHTML }}
              />
            </CheckBox>
          </div>
        );
      })}
    </div>
  );
};

export default AcceptOurConsent;
